import { formatNumber } from "../../../helpers/number/numberFormat"
import { useEffect, useState } from 'react'
import theme from "../../theme"
import { Box } from '../Box'
import { LoadComponent, Text } from '..'
import { NextButton } from "../Button"
import { Icon } from "../Icon"
import { Image } from "../Image"
import { openCompanyTab } from '../../../helpers/cretool-extjs/Tabs'
import api from "../../../services/api";
import '../css/scroll.css'
import { useApp } from '../../../contexts';
import { getCoinCountryLabel, translateText } from '../../../helpers/util';

export const IndustrialTransactionGrid = ({ industrialId, vmvi }) => {
    const [transactions, setTransactions] = useState([])
    const [load, setLoad] = useState(false)
    const { language, translations, userCountry, buildingCountry } = useApp();

    useEffect(() => {
        // setLoad(true)
        api.get(`/industrial/${industrialId}/lasttransactions`).then(response=>{
            const { transactions } = response.data;            
            setTransactions(transactions)
            // setLoad(false)
        });
       
    }, []);

    const handleClickLogoCompany = (transaction) => {
        transaction.id_contato = transaction.id_ocupante_crm;
        transaction.nome_contato = "";
        openCompanyTab(transaction);
    }

    const getTipoTransacao = (tipoTransacao) => {
        switch (tipoTransacao) {
            case "locacao":
                return "Locação";
                break;
            case "venda":
                return "Venda";
                break;
            case "renovacao_adiantamento":
                return "Renovação";
                break;
            default:
                return "";
                break;
        }
    }
    
    return (
        <LoadComponent isLoading={load}>
            <div className="scroll" style={{ overflowX: "hidden" }}>
                <table>
                    <thead style={{ position: "sticky", top: 0, backgroundColor: "white" }}>
                        <tr>
                            <th style={{ ...styles.transactionGridHeader, ...styles.textAlignLeft }} >{translateText("Últimas Transações", language, translations, userCountry)}</th>
                            <th style={{ ...styles.transactionGridHeader, ...styles.textAlignLeft }}> {translateText("Valor Nominal", language, translations, userCountry)} ({getCoinCountryLabel(buildingCountry)}/m²)</th>
                            <th style={{ ...styles.transactionGridHeader, ...styles.textAlignLeft }}> {translateText("Valor", language, translations, userCountry)} ({getCoinCountryLabel(buildingCountry)}/m²)</th>
                            <th style={{ ...styles.transactionGridHeader, ...styles.textAlignLeft }}> {translateText("CAP Rate", language, translations, userCountry)} (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        transactions.map((transaction, index) => {
                            return (
                                <tr key={`transaction-row-${index}`}>
                                    <td>
                                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                                            <div style={{ width: 80, height: 60, display: 'flex', alignItems: "center", justifyContent: "center", cursor: 'pointer'}} onClick={() => handleClickLogoCompany(transaction)}>
                                                {transaction.url_logotipo !== null && (
                                                    <Image url={transaction.url_logotipo} width={225} height={130} />
                                                )}
                                            </div>
                                            <div style={{ flexDirection: 'column', display: 'flex' , margin: 5}}>
                                                <Text style={styles.transactionGridColumnTextValue}>{ translateText(getTipoTransacao(transaction.tipo_transacao), language, translations, userCountry) + " - " + transaction.trimestre + "T " + transaction.ano}</Text>
                                                <Text style={styles.transactionGridColumnSubTextValue}>{formatNumber(transaction.area_transacao)}m²</Text>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ width: 120, ...styles.transactionGridColumn, ...styles.textAlignCenter }}>
                                            <Text style={styles.transactionGridColumnTextValue}>
                                                {formatNumber(transaction.valor_nominal, 2)}
                                            </Text>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ width: 120, ...styles.transactionGridColumn, ...styles.textAlignCenter }}>
                                            <Text style={styles.transactionGridColumnTextValue}>
                                                {formatNumber(transaction.valor_nominal/transaction.area_transacao, 2)}
                                            </Text>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ width: 120, ...styles.transactionGridColumn, ...styles.textAlignCenter }}>
                                            <Text style={styles.transactionGridColumnTextValue}>
                                                {formatNumber(((transaction.valor_nominal/transaction.area_transacao)/vmvi)*100*12, 2)}
                                            </Text>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
            {/* <div style={{ display: 'flex', flexDirection: 'column' }}>
            </div> */}
        </LoadComponent>
    )
}

const styles = {
    textAlignCenter: {
        textAlign: "center"
    },
    textAlignLeft: {
        textAlign: "left"
    },
    transactionGridHeader: {
        textAlign: "center",
        fontWeight: "600", 
        fontSize: 13,
        color: "#7A7B7C",
    },
    transactionGridColumnTextValue: { 
        color: "#000",
        fontWeight: "600", 
        fontSize: 16
    },
    transactionGridColumnSubTextValue: { 
        fontWeight: "600", 
        fontSize: 13,
        color: "#464648"
    }
}